import { useEffect } from "react";

export const SITE_URL = "https://www.kotamprojects.com";
const DEFAULT_IMAGE = `${SITE_URL}/hero-house.jpg`;

// Keep exactly one element matching `selector`; create it if missing.
function upsert(selector, create) {
  const nodes = document.head.querySelectorAll(selector);
  for (let i = 1; i < nodes.length; i += 1) nodes[i].remove();
  let el = document.head.querySelector(selector);
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  return el;
}

function setMetaByName(name, content) {
  const el = upsert(`meta[name="${name}"]`, () => {
    const m = document.createElement("meta");
    m.setAttribute("name", name);
    return m;
  });
  el.setAttribute("content", content);
}

function setMetaByProp(prop, content) {
  const el = upsert(`meta[property="${prop}"]`, () => {
    const m = document.createElement("meta");
    m.setAttribute("property", prop);
    return m;
  });
  el.setAttribute("content", content);
}

function setCanonical(href) {
  const el = upsert('link[rel="canonical"]', () => {
    const l = document.createElement("link");
    l.setAttribute("rel", "canonical");
    return l;
  });
  el.setAttribute("href", href);
}

// Imperatively manage per-page SEO tags and de-duplicate any that the
// platform script may have injected, so there is exactly one of each.
export const SEO = ({ title, description, path = "/", image = DEFAULT_IMAGE }) => {
  const url = `${SITE_URL}${path}`;

  useEffect(() => {
    const apply = () => {
      window.__desiredTitle = title;
      if (document.title !== title) document.title = title;
      setMetaByName("description", description);
      setCanonical(url);
      setMetaByProp("og:type", "website");
      setMetaByProp("og:site_name", "Kotam Projects");
      setMetaByProp("og:title", title);
      setMetaByProp("og:description", description);
      setMetaByProp("og:url", url);
      setMetaByProp("og:image", image);
      setMetaByName("twitter:card", "summary_large_image");
      setMetaByName("twitter:title", title);
      setMetaByName("twitter:description", description);
      setMetaByName("twitter:image", image);
    };
    apply();
    const enforce = setInterval(apply, 700);
    return () => clearInterval(enforce);
  }, [title, description, url, image]);

  return null;
};
